import { http } from 'utils'
import { set } from 'lodash'
import { SET_OBJECTIVES, ADD_OBJECTIVE, DELETE_OBJECTIVE, ADD_MILESTONE, DELETE_MILESTONE, SET_PROPERTY } from 'vx/mutations'

export const initialMilestoneState = () => ({
  description: null,
  start_date: null,
  end_date: null,
  outcome: null,
  achievements: null,
  what_worked_well: null,
  challenges: null,
  conduct_review: null,
  values_alignment: null
})

export const initialPerformanceObjectiveState = () => ({
  description: null,
  milestones: [
    initialMilestoneState()
  ]
})

const state = {
  objectives: [
    initialPerformanceObjectiveState()
  ]
}

const actions = {
  async getPerformanceObjectives ({ commit, rootState }) {
    const placement = rootState.placements.placement

    const response = await http.get(`/graduates/${placement.graduate_id}/placements/${placement.id}/start-component/performance`)

    commit(SET_OBJECTIVES, response.data.data)

    return response
  },

  async storePerformanceObjectives ({ commit, rootState }, payload) {
    const placement = rootState.placements.placement

    const response = await http.post(`/graduates/${placement.graduate_id}/placements/${placement.id}/start-component/performance`, payload)

    commit(SET_OBJECTIVES, response.data.data)

    return response
  },

  async updateEndPerformanceObjectives ({ commit, rootState }, payload) {
    const placement = rootState.placements.placement

    const response = await http.post(`/graduates/${placement.graduate_id}/placements/${placement.id}/end-component/objectives-outcome`, payload)

    return response
  },

  async requestEditAccess ({ commit, rootState }, payload) {
    const placement = rootState.placements.placement

    const response = await http.post(`/graduates/${placement.graduate_id}/placements/${placement.id}/start-component/request-edit-access`, payload)

    return response
  },

  async approveEditAccess ({ commit, rootState }, payload) {
    const placement = rootState.placements.placement

    const response = await http.post(`/graduates/${placement.graduate_id}/placements/${placement.id}/start-component/approve-edit-access`, payload)

    return response
  },

  setMilestoneProperty ({ commit }, { objectiveIndex, milestoneIndex, property, value }) {
    commit(SET_PROPERTY, {
      objectiveIndex,
      property: `milestones.${milestoneIndex}.${property}`,
      value
    })
  },

  setObjectiveProperty ({ commit }, { objectiveIndex, property, value }) {
    commit(SET_PROPERTY, { objectiveIndex, property, value })
  },

  addBlankObjective ({ commit }) {
    commit(ADD_OBJECTIVE, initialPerformanceObjectiveState())
  },

  deleteObjective ({ commit }, objectiveIndex) {
    commit(DELETE_OBJECTIVE, objectiveIndex)
  },

  addBlankMilestone ({ commit }, objectiveIndex) {
    commit(ADD_MILESTONE, { objectiveIndex, milestone: initialMilestoneState() })
  },

  deleteMilestone ({ commit }, { objectiveIndex, milestoneIndex }) {
    commit(DELETE_MILESTONE, { objectiveIndex, milestoneIndex })
  }
}

const mutations = {
  [SET_OBJECTIVES] (state, objectives) {
    if (objectives.length === 0) {
      state.objectives = [initialPerformanceObjectiveState()]
    } else {
      state.objectives = objectives
    }
  },

  [SET_PROPERTY] (state, { objectiveIndex, property, value }) {
    set(state.objectives[objectiveIndex], property, value)
  },

  [ADD_OBJECTIVE] (state, objective) {
    state.objectives.push(objective)
  },

  [DELETE_OBJECTIVE] (state, objectiveIndex) {
    state.objectives.splice(objectiveIndex, 1)
  },

  [ADD_MILESTONE] (state, { objectiveIndex, milestone }) {
    state.objectives[objectiveIndex].milestones.push(milestone)
  },

  [DELETE_MILESTONE] (state, { objectiveIndex, milestoneIndex }) {
    state.objectives[objectiveIndex].milestones.splice(milestoneIndex, 1)
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
